export const compare = {
  namespaced: true,

  state: {
    selectedNodes: [],
    unfilteredSelectedNodes: [],
  },

  mutations: {
    // RESET is done by SET_UNFILTERED_SELECTED_NODES([]), SET_SELECTED_NODES will be recalculated and called in CompareTree
    SET_UNFILTERED_SELECTED_NODES(state, val) {
      state.unfilteredSelectedNodes = val;
    },

    SET_SELECTED_NODES(state, val) {
      state.selectedNodes = val;
    },

    TOGGLE_NODE(state, val) {
      const nodeIdx = state.unfilteredSelectedNodes.findIndex(
        (d) => d.deveui === val.deveui && d.key === val.key
      );

      if (nodeIdx !== -1) {
        state.unfilteredSelectedNodes.splice(nodeIdx, 1);

        const nodeFilteredIdx = state.selectedNodes.findIndex(
          (d) => d.deveui === val.deveui && d.key === val.key
        );
        if (nodeFilteredIdx !== -1)
          state.selectedNodes.splice(nodeFilteredIdx, 1);

        return;
      }
      state.unfilteredSelectedNodes.push({
        deveui: val.deveui,
        key: val.key,
      });
      state.selectedNodes.push({ deveui: val.deveui, key: val.key });
    },
  },
};
